var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"red","outlined":"","dark":"","block":""},on:{"click":_vm.deleteVideo}},[_vm._v(" Delete Video ")])}
var staticRenderFns = []

export { render, staticRenderFns }